/*
    author：peter (185832959@qq.com)
    date：2018-07-04
*/
import Vue from 'vue'
import VueRouter from 'vue-router'

import routers from './auto-import'
import { loadScript } from 'common/auth'
import Layout from '@/views/components/layout'
import Cookies from 'js-cookie'
import config from 'common/config'
Vue.use(VueRouter)

export const constantStaticMap = [
    ...routers,
    {
        path: '/redirect',
        component: Layout,
        hide: true,
        children: [
            {
                path: '/redirect/:path*',
                component: () => import('@/views/page/redirect/index')
            }
        ]
    },
    {
        path: '/error',
        component: Layout,
        redirect: 'noredirect',
        name: 'ErrorPages',
        hide: true,
        meta: {
            title: 'errorPages',
            icon: '404'
        },
        children: [
            {
                path: '404',
                components: {
                    'public': () => import('@/views/page/errorPage/404')
                },
                name: 'Page404',
                meta: { title: 'page404', noCache: true, mode: 'public' }
            }
        ]
    },
    { path: '*', redirect: '/error/404', hide: true }
]
const router = new VueRouter({
    base: '/lzauth',
    mode: 'history',
    routes: constantStaticMap
})

router.beforeEach(async (to, from, next) => {
    // sdk 初始化
    await loadScript().then(function() {
        window.ucjssdk.ready(function() {
            // 回调函数，环境准备就绪时触发
            if (to.query.force_logout) {
                window.ucjssdk.sso.logout({
                    onSuccess: function (data) {
                        Cookies.set('lz_token', '', { domain: config.api.domain })
                    },
                    onFail: function (data) {
                        Cookies.set('lz_token', '', { domain: config.api.domain })
                    }
                })
            }
        })
    })
    next()
    // remove loading
    let $loading = document.querySelector('#appPageLoading')
    if ($loading) {
        document.body.removeChild($loading)
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js